import React from 'react';

const SelectedFaxContext = React.createContext(null);

export const SelectedFaxProvider = SelectedFaxContext.Provider;

export default SelectedFaxContext;
